import * as React from "react";
import constants from "constants/index";
import Styled from "styled-components/macro";
import Image, { GatsbyImageProps } from "gatsby-image";
import Media from "@uizard-io/styled-media-query";
import Headline from "../../texts/Headline";
import Button from "../../buttons/Button";
import Description from "../../texts/Description";
import RichDescription from "../../texts/RichDescription";
import Tagline from "../../texts/Tagline";
import Content from "../../layout/Content/Content";
import MediaQuery from "../../layout/MediaQuery";

const ContentExtended = Styled(Content)`
    margin-bottom: 10rem;
    
    ${Media.greaterThan("900px")`
        margin-bottom: 12rem;
    `}

    
`;

const ImageA = Styled(Image)`
`;

const Columns = Styled.div`
    display: flex;
    margin-top: 10rem;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
    
    ${Media.greaterThan("900px")`
        flex-direction: row;
        margin-top: 18rem;
    `}

    ${Media.greaterThan("medium")`
      margin-top: 15rem;
    `}
`;

const ColumnText = Styled.div`
    width: 100%;
    
     ${Media.greaterThan("900px")`
        width: 50%;
    `}
`;

const ColumnIllustration = Styled.div`
    width: 75%;
    max-width: 399px;
    margin-top: 5rem;
    
     ${Media.greaterThan("900px")`
        margin-top: 0;
        max-width: 634px;
        margin-left: 9rem;
    `}
`;

const SignupContainer = Styled.div`
  max-width: 33.5rem;
  
  ${Media.greaterThan("900px")`
        max-width: 43rem;
    `}
`;

const TaglineExtended = Styled(Tagline)`
  color: #7f7f7f;
`;

const NavButtonLink = Styled.a`
  
`;

type TemplatesLandingProps = {
  headline: string;
  description: string;
  imageA: GatsbyImageProps;
  imageB: GatsbyImageProps;
};

export default ({
  headline,
  description,
  imageA,
  imageB,
}: TemplatesLandingProps) => (
  <ContentExtended narrow>
    <Columns>
      <ColumnText>
        <TaglineExtended as="h1">UI Templates</TaglineExtended>
        <Headline as="h2">{headline}</Headline>
        <RichDescription content={description} />

        <NavButtonLink href={`https://${constants.APP_DOMAIN}/auth/sign-up`}>
          <Button solid>Sign up for free</Button>
        </NavButtonLink>
      </ColumnText>
      <ColumnIllustration>
        <MediaQuery lessThan="medium">
          <ImageA
            fluid={"fluid" in imageB ? imageB.fluid : null}
            alt="Uizard's AI can assist you every step of the way"
          />
        </MediaQuery>

        <MediaQuery greaterThan="medium">
          <ImageA
            fluid={"fluid" in imageA ? imageA.fluid : null}
            alt="Uizard's AI can assist you every step of the way"
          />
        </MediaQuery>
      </ColumnIllustration>
    </Columns>
  </ContentExtended>
);
